import { scrollbarTheme } from '../../../assets/customThemes/scrollbarTheme';

export const style = {
    container:{
        width:'73vw',
        display:'flex', 
        flexDirection:'row', 
        marginTop:'20px',
        gap: '20px',
        '@media (max-width: 600px)': {
            flexDirection:'column', 
            width: '90vw',
        }
    },
    messageArea: {
        padding: '16px 20px',
        marginBottom: '12px',
        backgroundColor: '#FFF',
        borderRadius: '16px',
        width: '100% !important',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        transition: 'all 0.2s ease',
        '@media (max-width: 600px)': {
            width: '100%',
            padding: '12px 16px',
            borderRadius: '12px',
        }
    },
    messageAreaUser: {
        padding: '16px 20px',
        marginBottom: '12px',
        backgroundColor: 'linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 100%)',
        background: '#f0f7ff',
        borderRadius: '16px',
        width: '100% !important',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        '@media (max-width: 600px)': {
            width: '100%',
            padding: '12px 16px',
        }
    },
    messageAreaAI: {
        padding: '16px 20px',
        marginBottom: '12px',
        backgroundColor: '#FFF',
        borderRadius: '16px',
        width: '100% !important',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #e8e8e8',
        '@media (max-width: 600px)': {
            width: '100%',
            padding: '12px 16px',
        }
    },
   sendArea: {
        marginTop: '12px',
        padding: '16px 20px',
        marginBottom: '10px',
        backgroundColor: '#FFF',
        borderRadius: '20px',
        width: '100% !important',
        border: '2px solid #00a271',
        boxShadow: '0 4px 12px rgba(0, 162, 113, 0.15)',
        transition: 'all 0.2s ease',
        flexShrink: 0,
        '@media (max-width: 600px)': {
            width: '100%',
            borderRadius: '16px',
        }
    },
    messageTitleArea:{
        display: 'flex', 
        width:'100%', 
        justifyContent: 'end', 
        marginRight:'10px'
    },
    title:{
        color:'#666670',
        fontSize: '12pt', 
        fontWeight: '600',
    },
    messageContainer:{
        display:'flex', 
        flexDirection:'column', 
        flex: 1,
        minHeight: 0,
        width: '100% !important',
        overflowY: "auto",
        padding: '8px',
        backgroundColor: 'transparent',
        borderRadius: '0',
        '@media (max-width: 600px)': {
            width: '100%',
            borderRadius: '0',
        },
        ...scrollbarTheme
    },
    cancelButton:{
        width: '180px',
        color:'black',
        backgroundColor: '#cfcfcf',
        borderRadius: '12px',
        ':hover': {
            backgroundColor: '#ebebeb',
        }
    },
    saveButton:{
        width: '180px',
        color:'white',
        backgroundColor: '#00a271',
        borderRadius: '12px',
        fontWeight: '600',
        ':hover':{
            backgroundColor: '#11B382',
        },
    },
    submitButton:{
        backgroundColor: '#00a271',
        borderRadius: '12px',
        fontWeight: '600',
        ':hover':{
            backgroundColor: '#11B382',
        },
    },
    submitCancelButton:{
        backgroundColor: '#CC3300',
        borderRadius: '12px',
        ':hover':{
            backgroundColor: '#DD4411',
        },
    },
    modelButton: {
        display:'flex', 
        borderRadius: '16px',
        flexDirection:'row', 
        justifyContent:'space-between', 
        width: 'auto',
        backgroundColor: '#f5f5f5',
        border: 'none',
        padding: '4px',
        cursor: 'pointer',
        gap: '4px',
    },
    modelButtonSelected:{
        borderRadius: '12px',
        backgroundColor: '#FFF',
        padding: '10px 18px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        transition: 'all 0.2s ease',
    },
    modelButtonNotSelected:{
        padding: '10px 18px',
        borderRadius: '12px',
        transition: 'all 0.15s ease',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: 'rgba(255,255,255,0.5)',
        }
    },
    identityButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 16px',
        backgroundColor: '#FFF',
        borderRadius: '16px',
        cursor: 'pointer',
        border: '1px solid #e0e0e0',
        transition: 'all 0.2s ease',
        ':hover': {
            backgroundColor: '#f8f8f8',
            borderColor: '#00a271',
        }
    },
    identityExpanded: {
        backgroundColor: '#FFF',
        borderRadius: '16px',
        padding: '16px',
        border: '2px solid #00a271',
        marginBottom: '16px',
    },
    attachButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '12px',
        backgroundColor: '#f5f5f5',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: 'none',
        ':hover': {
            backgroundColor: '#e8e8e8',
        }
    }
}
